import React from 'react';
import { onClickBtnStartTracking } from 'actions/ingredients/library';
import { getFormValues, Field } from 'redux-form';
import { connect } from 'react-redux';
import SettingField from 'components/Fields/ReduxForm/SettingField';
import styles from './LibraryInventoryAlert.css';

class LibraryInventoryAlert extends React.Component {
  render() {
    const { showInputInventory, libraryForm } = this.props;
    return (
      <div className="row">
        {showInputInventory && libraryForm && (
          <div>
            <div className="col-sm-12">
              <div className="col-sm-8" />
              <div className={`col-sm-4 ${styles['label-in-stock']}`}>
                IN STOCK
              </div>
            </div>
            <div className="mk-grouped-input">
              <div className="form-group col-sm-8">
                <Field
                  component="input"
                  name={`name`}
                  className={
                    libraryForm.id
                      ? `form-control ${styles['inv-name']}`
                      : `form-control ${styles['inv-name']} ${
                          styles['col-name']
                        }`
                  }
                  disabled={libraryForm.id}
                  placeholder="Ingredient Name"
                />
              </div>
              <div className="form-group col-sm-4">
                <Field
                  component={SettingField}
                  name={`in_stock`}
                  inputClassName={`text-right ${styles['inv-stock']}`}
                  readOnly={libraryForm.id}
                  positiveNumberOnly
                  maxFractionDigits={2}
                />
              </div>
            </div>
          </div>
        )}
        <div className="form-group col-sm-12">
          <button
            onClick={this._onClickStartTracking}
            className="btn btn-primary btn-block no-border-radius-top"
          >
            {showInputInventory
              ? 'Manage Ingredient Inventory and Alerts'
              : 'Start Tracking Ingredient Inventory and Alerts'}
          </button>
          <div className={styles['label-inner']}>
            <i className="fa fa-exclamation-circle" />
            <label>
              Ingredient stock is automatically tracked and can not be changed
              after saving the item, so please make sure that it is correct!
            </label>
          </div>
        </div>
      </div>
    );
  }

  _onClickStartTracking = e => {
    const { dispatch, libraryForm } = this.props;
    dispatch(onClickBtnStartTracking(libraryForm));
    e.stopPropagation();
    e.preventDefault();
  };
}

function mapStateToProps(state) {
  return {
    libraryForm: getFormValues('library')(state),
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LibraryInventoryAlert);
